"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeId = exports.onClickOutside = void 0;
/**
 * Listen for clicks on the `document` element, that are outside of {@link el} and call {@link callbackFunction}
 */
var onClickOutside = function (el, callbackFunction) {
    document.addEventListener('click', function () {
        callbackFunction.call({});
    });
    el.addEventListener('click', function (e) {
        e.stopPropagation(); // avoid running reset(), when clicking on el or any HTMLElement inside of el
    });
};
exports.onClickOutside = onClickOutside;
/**
 * Create a random string from a set of characters with a specific length
 * @param length Any number
 * @param charset Character set used to create id
 * @param pre Text to prepend
 * @returns Random string with characters from {@link charset} with the length of {@link length}
 */
var makeId = function (length, charset, pre) {
    if (charset === void 0) { charset = 'abcdefghijklmnopqrstuvwxyz'; }
    var result = '';
    if (pre)
        result += pre;
    for (var i = 0; i < length; i++) {
        result += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return result;
};
exports.makeId = makeId;
